import { render, staticRenderFns } from "./OrderAttribution.vue?vue&type=template&id=5c8e2f41&scoped=true"
import script from "./OrderAttribution.vue?vue&type=script&lang=js"
export * from "./OrderAttribution.vue?vue&type=script&lang=js"
import style0 from "./OrderAttribution.vue?vue&type=style&index=0&id=5c8e2f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e2f41",
  null
  
)

export default component.exports